import {Injectable} from "@angular/core";
import {AuthenticationService} from "../authentication.service";
import {TranslateService} from "@ngx-translate/core";
import {LabelingService} from "../../shared/labeling.service";
import {Language} from "../../shared/language.enum";
import moment from "moment-timezone";

@Injectable({providedIn: 'root'})
export class SwitchLanguageService {

  constructor(
    public authenticationService: AuthenticationService,
    public translateService: TranslateService,
    public labelingService: LabelingService,
  ) {
  }

  switchLanguage(language: Language): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('language', language);
    }
    this.translateService.use(language);
    this.labelingService.languageChanged(language);
    this.authenticationService.activeLanguageSubject.next(language);
    moment.locale(language)
  }

  isLanguageSelected(language: Language): boolean {
    return this.translateService.currentLang === language;
  }

  getSavedLanguageCode(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    return localStorage.getItem('language');
  }

  toLanguage(langCode: string): Language {
    switch(langCode)  {
      case "es":  return Language.SPANISH;
      case "de":  return Language.GERMAN;
      case "fr":  return Language.FRENCH;
      case "it":  return Language.ITALIAN;
      case "pt":  return Language.PORTUGUESE;
    }

    return Language.ENGLISH;
  }


}
